import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
  selector: 'tisa-article-block-metadata-button',
  templateUrl: './article-block-metadata-button.component.html',
  styleUrls: ['article-block-metadata-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ArticleBlockMetadataButtonComponent {
  @Input()
  value: number | undefined;
}
